if (!customElements.get('bulletpoint-section')) {
  customElements.define('bulletpoint-section', class BulletpointSection extends HTMLElement {
    constructor() {
      super();
      this.handleToggle = this.handleToggle.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('toggle', this.handleToggle, true);
      this.addEventListener('click', this.handleClick);
      this.closeExtraOpenItems();
    }

    disconnectedCallback() {
      this.removeEventListener('toggle', this.handleToggle, true);
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(evt) {
      const summary = evt.target.closest('summary');

      if (!summary || !this.contains(summary)) return;

      const details = summary.closest('details');

      if (!details || !details.open) return;

      this.ensureClosed(details);
    }

    handleToggle(evt) {
      const details = evt.target;

      if (!(details instanceof HTMLDetailsElement) || !details.open) return;

      this.querySelectorAll('details[open]').forEach((openDetails) => {
        if (openDetails === details) return;

        const disclosure = openDetails.closest('details-disclosure');

        if (disclosure && typeof disclosure.close === 'function') {
          disclosure.close();
          this.ensureClosed(openDetails);
        } else {
          openDetails.open = false;
        }
      });
    }

    ensureClosed(details) {
      window.setTimeout(() => {
        if (!details.classList.contains('is-closing')) return;

        this.forceClose(details);
      }, 500);
    }

    closeExtraOpenItems() {
      const openItems = Array.from(this.querySelectorAll('details[open]'));

      openItems.slice(1).forEach((details) => this.forceClose(details));
    }

    forceClose(details) {
      const panel = details.querySelector('.disclosure__panel');

      details.classList.remove('is-closing');
      details.open = false;

      if (panel) panel.removeAttribute('style');
    }
  });
}
